/**
 * 지금 언어의 도움말 문서를 고른다. 없는 언어면 한국어(원문)로 — 반쯤 번역된 안내보다 낫다.
 *
 * `allHelpContents()` 는 **버튼 글 대조**에 쓴다. 도움말 대화 중에 언어를 바꿀 수 있으므로, 사용자가 누른
 * 버튼의 글이 어느 언어의 것이든 알아봐야 대화가 끊기지 않는다(helpWorkflow).
 */
import i18n from '../../i18n';
import type { HelpContent } from './types';
import ko from './ko';
import en from './en';

const BY_LANG: Record<string, HelpContent> = { ko, en };

export function helpContent(): HelpContent {
  const lang = String(i18n.language || 'ko').split('-')[0];
  return BY_LANG[lang] || ko;
}

export function allHelpContents(): HelpContent[] {
  return [ko, en];
}

export type { HelpContent };
export default helpContent;
